<template>
  <div class="image-item" @click.stop="jumpClassPage">
    <img
      class="image-class"
      :src="(data && data._list && data._list.data) || defaultImage"
    />
    <div
      class="mask"
      :class="{ 'mask-bg': !data || !data._list || !data._list.data }"
    >
      <text class="iconfont icon-huati"></text>
      <div class="name">{{ data.name }}</div>
      <div class="count">{{ (data._list && data._list.total) || 0 }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        {
        }
      }
    }
  },
  components: {},
  data() {
    return {
      defaultImage: ''
    }
  },
  methods: {
    concatUrlParams(params) {
      let str = ''
      let isFirst = true
      for (let i in params) {
        let itemStr
        let paramStr =
          typeof params[i] == 'string' ? params[i] : JSON.stringify(params[i])
        if (isFirst) {
          itemStr = '?' + i + '=' + paramStr
          isFirst = false
        } else {
          itemStr = '&' + i + '=' + paramStr
        }
        str = str + itemStr
      }
      return str
    },
    jumpClassPage() {
      let params = {
        id: this.data.id,
        title: this.data.name
      }
      let str = this.concatUrlParams(params)
      this.$router.push({
        path: '/fatcamp/knowledge-base/picture-class',
        query: params
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.image-class {
  width: 100%;
  height: 100%;
}
.image-item {
  overflow: hidden;
  position: relative;
  background-color: #f1f1f1;
  width: 108px;
  height: 108px;
  border-radius: 1.1vw;
}
.mask {
  background-color: rgba(30, 53, 102, 0.5);
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-size: 15px;
  color: #fff;
  overflow: hidden;
}
.mask-bg {
  background-color: rgb(135, 146, 171);
}
.iconfont {
  color: #fff;
  font-size: 4.8vw;
  margin-bottom: 7px;
}
.name {
  overflow: hidden;
  line-height: 21px;
  width: 100%;
  padding: 0vw 2vw;
  box-sizing: border-box;
  text-align: center;
}
.count {
  line-height: 14px;
  font-family: PingFangSC-Medium;
  font-size: 10px;
  color: #fff;
  text-align: center;
}
</style>
